

$( document ).ready(function(){
  $('.open-login-modal').click(function(){
    $('#signup-modal').hide();
    $('.common-modal__overlay').addClass('active');
    $('#login-modal').show().css('display', 'flex');
  });
  $('.open-signup-modal').click(function(){
    $('#login-modal').hide();
    $('.common-modal__overlay').addClass('active');
    $('#signup-modal').show().css('display', 'flex');
  });

  $('.close-modal').click(function () {
    $('.common-modal__overlay').removeClass('active');
    $('.common-modal').hide();
  });

  $('.common-modal__overlay').click(function () {
    $('.common-modal__overlay').removeClass('active');
    $('.common-modal').hide();
  });
  $('.common-modal').click(function (event) {
    event.stopPropagation();
  });

  $('.btnClose').click(function(event){
    event.preventDefault();
  });
});

// なぜかこれがないと読み込んでくれない
$(document).on('turbolinks:load', function() { 
  $('.open-login-modal').click(function(){
    $('#signup-modal').hide();
    $('.common-modal__overlay').addClass('active');
    $('#login-modal').show().css('display', 'flex');
  });
  $('.open-signup-modal').click(function(){
    $('#login-modal').hide();
    $('.common-modal__overlay').addClass('active');
    $('#signup-modal').show().css('display', 'flex');
  });

  $('.close-modal').click(function () {
    $('.common-modal__overlay').removeClass('active');
    $('.common-modal').hide();
  });

  $('.common-modal__overlay').click(function () {
    $('.common-modal__overlay').removeClass('active');
    $('.common-modal').hide();
  });
  $('.common-modal').click(function (event) {
    event.stopPropagation();
  });

  $('.btnClose').click(function(event){
    event.preventDefault();
  });
});

